import axios from 'axios';
import getEnv from '../helpers/getEnv';

const apiClient = axios.create({
    baseURL: getEnv('API_URL'),
    withCredentials: true,
});

export default apiClient;
